import React from 'react';
import { useSlate, ReactEditor } from 'slate-react';
import { isMarkActive, toggleMark } from './helpers/utilities';
import ButtonBase from './ButtonBase';

interface Props {
  format: string;
  Icon: React.ReactNode;
}

function MarkButton({ format, Icon }: Props) {
  const editor = useSlate() as ReactEditor;
  const isActive = isMarkActive(editor, format);
  const handleMouseDown = (e: any) => {
    e.preventDefault();
    toggleMark(editor, format);
  };

  return (
    <ButtonBase onMouseDown={handleMouseDown} isActive={isActive}>
      {Icon}
    </ButtonBase>
  );
}

export default MarkButton;
